/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Picker } from '../../../assets/date-picker-icon.svg';

import { DatePicker, Input, Button } from 'antd';
import CustomInputNumber from '../../../components/CustomInputNumber/CustomInputNumber';
import { numberWithSpaces } from '../../../helpers/formatInteger';
import dayjs from 'dayjs';
import { CustomTextarea } from '../../../components/CustomTextfield/CustomTextfield';
import { ReactComponent as IconPlus } from '../img/pluse-icon.svg';
import { ReactComponent as Save } from '../../../assets/save-disket-icon.svg';
import { ReactComponent as Cancel } from '../../../assets/cancel-icon-min.svg';

const Step02Details = ({ details, setDetails, step, stepData, stage }) => {
  const { t } = useTranslation('');
  const tagsDefault = ['Me', 'Family', 'My Partner', 'With Friends'];
  const [tagsArray, setTagsArray] = useState(tagsDefault);

  const [isAddTag, setIsAddTag] = useState(false);
  const [newTag, setNewTag] = useState('');

  useEffect(() => {
    console.log('🚀 ~ Step02Details ~ details:', details);
  }, [details]);
  useEffect(() => {
    console.log('🚀 ~ Step02Details ~ tagsArray:', tagsArray);
  }, [tagsArray]);

  useEffect(() => {
    if (details?.tags) {
      const newTags = details?.tags.filter((tag) => !tagsArray.includes(tag));
      setTagsArray([...tagsArray, ...newTags]);
    }
  }, [details.tags]);

  useEffect(() => {
    if (step === 3 && stage?.start_year && stage?.end_year) {
      const currentMonth = dayjs().month();

      if (!details?.start_date) {
        const startDate = dayjs()
          .year(stage.start_year)
          .month(currentMonth)
          .format('YYYY-MM-DD');

        const endDate = dayjs()
          .year(stage.end_year)
          .month(currentMonth)
          .format('YYYY-MM-DD');

        setDetails({
          ...details,
          start_date: startDate,
          end_date: endDate,
        });
      }
    }
  }, [step, stage, details?.start_date]);

  const selectOptions = [
    {
      value: 2,
      label: t('ANNUAL'),
    },
    {
      value: 1,
      label: t('MONTHLY'),
    },
    {
      value: 0,
      label: t('ONE_TIME'),
    },
  ];

  const handleChange = (e) => {
    const name = e.target.value;
    setDetails({ ...details, name });
  };

  const handleChangeAmount = (amount) => {
    setDetails({ ...details, amount });
  };

  const changeFrequency = (frequency) => {
    setDetails({ ...details, frequency });
  };

  const handleChooseStart = (start_date) => {
    setDetails({
      ...details,
      start_date: dayjs(start_date).format('YYYY-MM-DD'),
    });
  };

  const handleChooseEnd = (end_date) => {
    setDetails({ ...details, end_date: dayjs(end_date).format('YYYY-MM-DD') });
  };

  const disabledMonth = (current) => {
    const startSelected = details.start_date || '';
    const start = current < dayjs().startOf('month');
    const end = current < dayjs(startSelected).startOf('month');

    // Ограничиваем даты рамками stage
    const beforeStageStart = stage?.start_year
      ? current < dayjs().year(stage.start_year).startOf('year')
      : false;
    const afterStageEnd = stage?.end_year
      ? current > dayjs().year(stage.end_year).endOf('year')
      : false;

    return { start, end, beforeStageStart, afterStageEnd };
  };

  const handleChangeDescription = (description) => {
    setDetails({ ...details, description });
  };

  const handleSelectTag = (tag) => {
    if (!details?.tags?.includes(tag)) {
      setDetails({
        ...details,
        tags: details?.tags ? [...details.tags, tag] : [tag],
      });
    } else {
      setDetails({
        ...details,
        tags: details?.tags?.filter((t) => t !== tag),
      });
    }
  };

  const handleAddTag = () => {
    setIsAddTag(true);
  };

  const handleChangeTag = (e) => {
    setNewTag(e.target.value);
  };

  const handleSubmitTag = () => {
    setDetails({
      ...details,
      tags: details?.tags ? [...details.tags, newTag] : [newTag],
    });
    setIsAddTag(false);
    setNewTag('');
  };

  const hendleCancelTag = () => {
    setIsAddTag(false);
    setNewTag('');
  };

  return (
    <div className="stageitem-point">
      <h1 className="item-point-title">{t(stepData[step])}</h1>
      {step === 0 && (
        <div className="name-input-wrapper">
          <Input
            placeholder={t('type away')}
            name="name"
            value={details?.name}
            onChange={handleChange}
            className="custom-input full-width finplan-input"
          />
          <div className="finplan-item-create-description">
            <label className="">{t('DESCRIPTION_OPTIONAL')}</label>
            <CustomTextarea
              width={'100%'}
              rows={4}
              name="description"
              placeholder={t('ENTER_DESCRIPTION')}
              value={details?.description}
              onChange={(e) => handleChangeDescription(e.target.value)}
            />
          </div>
          <label className="finplan-tags-label">{t('TAGS_OPTIONAL')}</label>
          <div className="finplan-tags-wrapper">
            {tagsArray.map((tag) => (
              <div
                key={tag}
                className={`finplan-tag ${details?.tags?.includes(tag) ? 'selected' : ''}`}
                onClick={() => handleSelectTag(tag)}
              >
                {tag}
              </div>
            ))}
            <Button
              type="text"
              icon={<IconPlus />}
              className="finplan-tag-add-button"
              onClick={() => handleAddTag('')}
            />
          </div>
          {isAddTag && (
            <div className="add-tag-wrapper">
              <Input
                placeholder={t('type away')}
                value={newTag}
                onChange={handleChangeTag}
                className="custom-input finplan-input"
              />
              <div className="add-tag-button-wrapper">
                <Button
                  icon={<Save />}
                  disabled={!newTag}
                  type="text"
                  onClick={() => handleSubmitTag()}
                />
                <Button
                  icon={<Cancel />}
                  type="text"
                  onClick={hendleCancelTag}
                />
              </div>
            </div>
          )}
        </div>
      )}
      {step === 1 && (
        <div className="frequency-wrapper">
          {selectOptions.map((i, index) => {
            return (
              <div
                key={i.value}
                className={`item-point ${details?.frequency === i.value ? 'selected' : ''}`}
                onClick={() => changeFrequency(i.value)}
              >
                {i.label}
              </div>
            );
          })}
        </div>
      )}
      {step === 2 && (
        <div className="amount-input-wrapper">
          <CustomInputNumber
            placeholder={t('AMOUNT')}
            suffix={'sek'}
            value={details?.amount}
            onChange={(amount) => handleChangeAmount(amount)}
            className="custom-input full-width finplan-input"
            controls={false}
            formatter={(value) => (!value ? '' : numberWithSpaces(value))}
            parser={(value) =>
              value ? value.replace(/( *)/g, '').replace(/,/g, '.') : ''
            }
          />
          {/* {itemType === 'expenses' &&
            <p className='amount-input-footer'>
            {t('Available budget')}
            <span>{numberWithSpaces(currentTotal)}</span> SEK
          </p>} */}
        </div>
      )}
      {step === 3 && (
        <div className="stageitem-date-wrapper">
          <div className="stageitem-date-row">
            <span>{t('START')}</span>
            <DatePicker
              disabled={!details?.frequency && details?.frequency !== 0}
              picker={'month'}
              disabledDate={(current) => {
                if (details?.frequency === 2) {
                  const { start, beforeStageStart, afterStageEnd } =
                    disabledMonth(current);
                  return start || beforeStageStart || afterStageEnd;
                } else {
                  const { start, beforeStageStart, afterStageEnd } =
                    disabledMonth(current);
                  return start || beforeStageStart || afterStageEnd;
                }
              }}
              placeholder={t('ENTER_START')}
              format={'YYYY-MM'}
              className="model-datepicker"
              suffixIcon={<Picker />}
              value={details?.start_date ? dayjs(details?.start_date) : null}
              defaultPickerValue={
                stage?.start_year ? dayjs().year(stage.start_year) : dayjs()
              }
              onChange={(value, dateString) => {
                if (value) {
                  handleChooseStart(value);
                }
              }}
            />
          </div>
          {details?.frequency !== 0 && (
            <div className="stageitem-date-row">
              <span>{t('END')}</span>
              <DatePicker
                disabled={!details?.frequency}
                picker={'month'}
                disabledDate={(current) => {
                  if (details?.frequency === 2) {
                    const { start, beforeStageStart, afterStageEnd } =
                      disabledMonth(current);
                    return start || beforeStageStart || afterStageEnd;
                  } else {
                    const { start, beforeStageStart, afterStageEnd } =
                      disabledMonth(current);
                    return start || beforeStageStart || afterStageEnd;
                  }
                }}
                placeholder={t('ENTER_END')}
                format={'YYYY-MM'}
                className="model-datepicker"
                suffixIcon={<Picker />}
                value={details?.end_date ? dayjs(details?.end_date) : null}
                defaultPickerValue={
                  stage?.start_year ? dayjs().year(stage.start_year) : dayjs()
                }
                onChange={(value, dateString) => {
                  if (value) {
                    handleChooseEnd(value);
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
      <div></div>
    </div>
  );
};

export default Step02Details;

Step02Details.propTypes = {
  details: PropTypes.object,
  setDetails: PropTypes.func,
  currentTotal: PropTypes.number,
  itemType: PropTypes.string,
  step: PropTypes.number,
  stepData: PropTypes.array,
  stage: PropTypes.object,
};
